import { Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IModal } from '../modal.interface';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [],
  templateUrl: './modal.component.html',
})
export default class ModalComponent {

  // Objeto que contiene los datos del modal
  @Input() modalData!: IModal;

  constructor(
      public activeModal: NgbActiveModal
  ) {}
}
